import script from "./ApplicationStatusTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationStatusTag.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationStatusTag.vue?vue&type=style&index=0&id=46c2dbc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46c2dbc0"]])

export default __exports__